import { IWebsiteBuilderFormItemOptionRaw } from "redux/reducers/models/websiteBuilder";

export interface IFormBuilderItemOption {
  id: number;
  formItemId: number;
  label: string;
  value: string;
}

export function isWebsiteBuilderFormItemOptionRawValid(rawOption: IWebsiteBuilderFormItemOptionRaw): boolean {
  return (
    rawOption?.id != null &&
    rawOption?.form_item_id != null
  );
}